import React from 'react';
import ContactHero from './components/ContactHero';
import ContactForm from './components/ContactForm';
import LocationMap from './components/LocationMap';
import ContactInfo from './components/ContactInfo';
import PrivacyNotice from './components/PrivacyNotice';

export default function Contact() {
  return (
    <div id="top" className="min-h-screen bg-gray-50">
      <ContactHero />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 -mt-20">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          <div className="space-y-8">
            <ContactInfo />
            <ContactForm />
            <PrivacyNotice />
          </div>
          <LocationMap />
        </div>
      </div>
    </div>
  );
}
